import { type ReactNode } from "react";
import {
  DrawerRoot,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerBody,
} from "@/components/drawer";

export interface TooltipDrawerRootProps {
  children: ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  onClose?: () => void;
}

export const TooltipDrawerRoot = ({
  open,
  setOpen,
  onClose,
  children,
}: TooltipDrawerRootProps): JSX.Element => {
  return (
    <DrawerRoot open={open} setOpen={setOpen} onClose={onClose}>
      <DrawerContent>{children}</DrawerContent>
    </DrawerRoot>
  );
};

interface TooltipDrawerTitleProps {
  children: ReactNode;
}

export const TooltipDrawerTitle = ({
  children,
}: TooltipDrawerTitleProps): JSX.Element => (
  <DrawerHeader>
    <DrawerTitle>{children}</DrawerTitle>
  </DrawerHeader>
);

interface TooltipDrawerBodyProps {
  children: ReactNode;
}

export const TooltipDrawerBody = ({ children }: TooltipDrawerBodyProps): JSX.Element => (
  <DrawerBody>{children}</DrawerBody>
);
